import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import { Box, Typography } from '@mui/material';

const OEBarChart = ({ data, onOEClick, selectedOE }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          flexDirection: 'column',
        }}
      >
        <Typography variant="h6" sx={{ color: '#666' }}>
          No OE data available
        </Typography>
      </Box>
    );
  }

  const sortedData = [...data]
    .sort((a, b) => b.value - a.value)
    .slice(0, 10);

  const handleBarClick = (barEntry) => {
    if (!onOEClick) return;
    // Toggle: clicking the already-selected OE clears the filter
    onOEClick(barEntry.oe === selectedOE ? null : barEntry.oe);
  };

  return (
    <Box sx={{ width: '600px', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={sortedData}
          margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="oe" type="category" width={140} />
          <Tooltip />
          <Bar
            dataKey="value"
            radius={[0, 4, 4, 0]}
            cursor="pointer"
            onClick={(barEntry) => handleBarClick(barEntry)}
          >
            {sortedData.map((entry) => {
              const isSelected = selectedOE && entry.oe === selectedOE;
              const isOtherSelected = selectedOE && entry.oe !== selectedOE;
              return (
                <Cell
                  key={entry.oe}
                  fill={isSelected ? '#0057A8' : isOtherSelected ? '#90CAF9' : '#003781'}
                  opacity={isOtherSelected ? 0.5 : 1}
                />
              );
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default OEBarChart;
